import ObjectData from './ObjectData';
import type { ObjectProperties, ObjectRawData } from './ObjectData';

/** Pagina de contenido tal cual llega del REST. */
export interface PageRawData extends ObjectRawData {
    title?: string;
    body_html?: string;
    extra_html?: string;
}

/** Entrada del indice de paginas del sitio. @see PageData.getSitePages */
export interface SitePage {
    /** Drupal nid */
    id: number;
    /** Default title */
    title: string;
}

/**
 * Object to store Page data.
 */
class PageData extends ObjectData {

    // Solo estrecha el tipo del campo de ObjectData: `declare` no emite nada.
    declare data?: PageRawData;

    // Common node properties.
    title?: string;
    // Declarados de siempre, pero nadie los asigna ni los lee.
    language?: string;
    created?: string | number;
    changed?: string | number;

    // Main content HMTL
    contentHtml?: string;

    // Full HTML from 'services' view mode.
    extraHtml?: string;

    /**
     * Class constructor.
     */
    constructor(id: number | string, properties?: ObjectProperties, data?: PageRawData) {
      super('page', id, properties, data)

      if (data) {
        // parseInt ya convertia el argumento a cadena de forma implicita.
        this.id = parseInt(String(id))
        this.title = data.title;
        this.contentHtml = data.body_html;
        this.extraHtml = data.extra_html ? data.extra_html : '';
      }
    }

    /**
     * Gets the page title.
     */
    getTitle(): string | undefined {
      return this.title;
    }

    /**
     * Gets the page content as HTML.
     */
    getContent(): string | undefined {
      return this.contentHtml;
    }

    /**
     * Gets the page URL.
     */
    getPageUrl(): string | undefined {
      return this.url;
    }

    /**
     * Gets site pages, each having:
     * - id: Drupal nid
     * - title: Default title
     *
     * @return Indexed by page name.
     */
    static getSitePages(): Record<string, SitePage> {
      return {
        legal_usage: {id: 1424, title: 'Terms of Use'},
        legal_privacy: {id: 16620, title: 'Privacy Policy'},
        legal_cookies: {id: 78787, title: 'Cookie Policy'},
      }
    }
}

export default PageData;
